import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import OverflowButton from "../../../../generic/overflowButton";
import { IListObj } from "../../../../types/genericTypes";

export interface IHoldEqUsableRowDskProps {
  rowData: any;
}

const overflowBtnDropdownOptions: Array<IListObj> = [
  { value: "buy", display: "Buy" },
  { value: "sell", display: "Sell" },
];

const HoldEqUsableRowDsk: React.FC<IHoldEqUsableRowDskProps> = (props) => {
  return (
    <li className="data_row">
      <div className="row1">
        <div className="col trdSym robotoM">
          <span
            dangerouslySetInnerHTML={{ __html: props.rowData.trdSym }}
          ></span>
        </div>
        <div className="col qty w_80">
          {props.rowData.cncRmsHdg ? toINR(props.rowData.cncRmsHdg.qty) : "—"}
        </div>
        <div className="col t1HQty w_80">
          {props.rowData.cncRmsHdg
            ? toINR(props.rowData.cncRmsHdg.t1HQty)
            : "—"}
        </div>
        <div className="col usdQty w_80">
          {props.rowData.cncRmsHdg
            ? toINR(props.rowData.cncRmsHdg.usdQty)
            : "—"}
        </div>
        <div className="col totQty w_80">
          {props.rowData.cncRmsHdg
            ? toINR(props.rowData.cncRmsHdg.totQty)
            : "—"}
        </div>
        <div className="col ltp w_80">{toINR(props.rowData.ltp, 2)}</div>
        <div className="col hdgVl w_90">
          {props.rowData.cncRmsHdg
            ? toINR(props.rowData.cncRmsHdg.hdgVl, 2)
            : "—"}
        </div>
        <div className="col overflowBtn">
          <OverflowButton
            dropdownOptions={overflowBtnDropdownOptions}
            onSelect={(id, data) => {
              //	console.log(id, data);
            }}
            showBuySellColor
          />
        </div>
      </div>
      <div className="row2">
        <div className="col trdSym">MTF holding values:</div>
        <div className="col qty w_80">
          {props.rowData.mtfRmsHdg ? toINR(props.rowData.mtfRmsHdg.qty) : "—"}
        </div>
        <div className="col t1HQty w_80">
          {props.rowData.mtfRmsHdg
            ? toINR(props.rowData.mtfRmsHdg.t1HQty)
            : "—"}
        </div>
        <div className="col usdQty w_80">
          {props.rowData.mtfRmsHdg
            ? toINR(props.rowData.mtfRmsHdg.usdQty)
            : "—"}
        </div>
        <div className="col totQty w_80">
          {props.rowData.mtfRmsHdg
            ? toINR(props.rowData.mtfRmsHdg.totQty)
            : "—"}
        </div>
        <div className="col ltp w_80">—</div>
        <div className="col hdgVl w_90">
          {props.rowData.mtfRmsHdg
            ? toINR(props.rowData.mtfRmsHdg.hdgVl, 2)
            : "—"}
        </div>
      </div>
    </li>
  );
};

export default HoldEqUsableRowDsk;
